module.exports = __webpack_public_path__ + "static/saver-vs-spender-what-are-they-saving-for-2017-4-36d18074ec898a0a6693600443dc6601.png";